import React from "react";

const storeDomain = {
  messageProvider: {
    messageBefore: (message) =>
      new Promise(function (resolve) {
        let confirmed = window.confirm(message);
        return resolve(confirmed);
      }),
    messageAfter: (message) =>
      new Promise(function (resolve) {
        window.alert(message);
        return resolve(true);
      }),
    messageError: (message) =>
      new Promise(function (resolve) {
        window.alert(message);
        return resolve(true);
      }),
    messagePendingChanges: (message) =>
      new Promise(function (resolve) {
        let confirmed = window.confirm(message);
        return resolve(confirmed);
      }),
  },
};

const DomainModelContext = React.createContext();

DomainModelContext.displayName = "domain-model-manager";

export { storeDomain };
export default DomainModelContext;
